import { Box, Modal } from "@mui/material";
import { ContainerActions, ContainerModalStyled } from "./confirm-modal.styled";
import { NormalText } from "../styles";
import { Button } from "../button/button";

export const ConfirmModal = ({
  children,
  isOpen,
  title,
  handleClose,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      dismiss={{ enabled: false }}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(220, 215, 215, 0.25)",
        },
      }}
    >
      <ContainerModalStyled>
        {title && (
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={"1px solid #cbcbcb"}
            padding={"0 24px 24px 24px"}
            marginBottom={"24px"}
          >
            <NormalText size={18} isBold color="#0F110C">
              {title?.toUpperCase()}
            </NormalText>
            <Button
              onClick={handleClose}
              startIcon={"X"}
              type={"regular"}
              iconSize={18}
            />
          </Box>
        )}
        <Box width={"100%"} padding={"0 24px 24px 24px"}>
          {children}
        </Box>
        <ContainerActions>
          {onCancel && (
            <Button label={"Cancelar"} onClick={onCancel} type={"regular"} />
          )}
          {onConfirm && (
            <Button
              label={"Confirmar"}
              onClick={onConfirm}
              type={"contained"}
            />
          )}
        </ContainerActions>
      </ContainerModalStyled>
    </Modal>
  );
};
